import GeneralModal from './GeneralModal';

export default GeneralModal;
